module.exports = __webpack_public_path__ + "img/rg2.9a35cf34.jpg";